<div class="gov-card">
  <div class="gov-card__header">{{ edit ? 'Edycja' : 'Dodanie' }} posiadacza</div>
  <div class="gov-card__body">
    <form *ngIf="form as form" novalidate autocomplete="off" [formGroup]="form">
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"cardNumber" as controlName'>
            <label [for]='controlName'>
              Numer karty
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu numer karty'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"houseNumber" as controlName'>
            <label [for]='controlName'>
              Nr domu *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr domu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"apartmentNumber" as controlName'>
            <label [for]='controlName'>
              Nr mieszkania
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr mieszkania'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="form-actions">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          <i class="fa fa-trash" aria-hidden="true"></i>Anuluj
        </button>
        <button type="button" class="btn btn-secondary" (click)="onSubmit()">
          @if (!edit) {
            <i class="fa fa-plus" aria-hidden="true"></i>Zapisz dane posiadacza
          } @else {
            <i class="fa fa-save"></i>Zaktualizuj dane posiadacza
          }
        </button>
      </div>
    </form>
  </div>
</div>
